//@ts-nocheck
import clsx from "clsx";
import * as React from "react";
import { useMemo, useEffect } from "react";
import { HTMLAttributes, useState } from "react";
import { CheckboxProps } from "../@types/checkbox";

function Checkbox(props: CheckboxProps & HTMLAttributes<HTMLInputElement>) {
  const {
    id,
    label,
    checked,
    onChange,
    getValue,
    className,
    value = "",
    name = "checkbox",
    color = "primary",
  } = props;

  const [selected, setSelected] = useState(checked);

  useEffect(() => {
    setSelected(checked);
  }, [checked]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const check = e.target.checked;
    setSelected(check);
    onChange?.(e);
    getValue?.(check);
  };

  return (
    <div className={clsx("form-check", color)}>
      <input
        id={id}
        name={name}
        value={value}
        type="checkbox"
        checked={selected}
        onChange={handleChange}
        className={clsx("form-check-input", className)}
      />
      <label className="form-check-label" htmlFor="flexCheckChecked">
        {label}
      </label>
    </div>
  );
}

const Group = (props: CheckboxProps & HTMLAttributes<HTMLInputElement>) => {
  const { children, defaultValue, ...other } = props;

  const items = useMemo(() => {
    const list = React.Children.toArray(children);
    const itemsList = [];
    for (let i in list) {
      if (list[i]?.props) {
        const { value, label } = list[i].props;

        if (list[i].type === Checkbox) {
          itemsList.push(
            <Checkbox
              key={i}
              value={value}
              label={label}
              checked={defaultValue?.includes(value)}
              {...other}
            />
          );
        }
      }
    }
    return itemsList;

  }, [children]);

  return <React.Fragment>{items}</React.Fragment>;
};
Checkbox.Group = Group;

export default Checkbox;
